export default {
  // Page title
  'adsReport.title': 'Data Report & Analysis',

  // Search fields
  'adsReport.agentName': 'Agent Name',
  'adsReport.adsPlatform': 'Attribution Platform',
  'adsReport.adsName': 'Attribution Name',
  'adsReport.eventName': 'Attribution Event',
  'adsReport.dateRange': 'Date Range',

  // Buttons
  'adsReport.search': 'Search',
  'adsReport.reset': 'Reset',
  'adsReport.export': 'Export',

  // Table columns
  'adsReport.serial': 'Serial',
  'adsReport.date': 'Date',
  'adsReport.uploadCount': 'Upload Count',
  'adsReport.successCount': 'Success Count',

  // Messages
  'adsReport.fetchDataFailed': 'Failed to fetch data',
  'adsReport.noData': 'No data',
  'adsReport.exportSuccess': 'Export task submitted, please check the download list',
  'adsReport.exportFailed': 'Export failed',

  // Pagination
  'adsReport.totalRecords': 'Total {total} records',
  'adsReport.pagination': 'Page {current} of {page}, Total {total} records',
};
